import React from "react";
import { Button } from "@vds/buttons";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { ErrorModalContainer } from "../EACreate/ea-create-styles";

const ErrorModal = ({ opened, title, body, footerButtonText, onClose, ariaLabel = "Error Modal" }) => {
  return (
    <Modal
      opened={opened}
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={true}
      ariaLabel={ariaLabel}
      hideCloseButton={true}
      closeButton={<></>}
    >
      <ModalTitle>{title}</ModalTitle>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <ErrorModalContainer>
          <Button size="large" disabled={false} use="primary" onClick={onClose}>
            {footerButtonText}
          </Button>
        </ErrorModalContainer>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
